import { gql } from "@apollo/client";

// These slugs are the backend-confirmed scope of getAppCheckedInWorkersCount.
// Display names remain server-owned so renamed groups are reflected in help.
export const GET_APP_STAFF_SUMMARY_HELP_ROLES = gql`
    query AppStaffSummaryHelpRoles {
        installer: role(slug: "monteure") { id slug label }
        teamleader: role(slug: "sub_teamleader") { id slug label }
    }
`;
